import PropTypes from "prop-types";
import React from "react";

import { Grid, Checkbox, FormGroup, FormControlLabel } from "@material-ui/core";

/**
 *
 * @param form : The form object
 * @param collection: An array of items
 * @param selectionType: value selected from the list of items
 * @param callback: A callback function to be passed in
 * @returns A jsx with the specified params
 */

const MultiCheckboxes = ({ form, collection, selectionType, callback }) => (
  <FormGroup row>
    <Grid container>
      {collection.map((item) => (
        <Grid item key={item} xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form[selectionType].includes(item)}
              onChange={(e) => callback(item, selectionType, e.target.checked)}
              value={item}
            />
          }
          label={item}
        />
        </Grid>
      ))}
    </Grid>
  </FormGroup>
);


MultiCheckboxes.propTypes = {
  form: PropTypes.object.isRequired,
  collection: PropTypes.array.isRequired,
  selectionType: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
};

export default MultiCheckboxes;
